export default "__VITE_ASSET__CmudPyRF__"